module.exports = {"BALL_LAYERS":5,"BALL_SIZE":75,"NUM_ORNAMENTS":6,"NUM_SNOWBALLS":6,"AREA_MAX":450,"AREA_MIN":350,"SCALE_MIN":0.7,"SCALE_MAX":1,"BRIGHTNESS_MAX":1,"BRIGHTNESS_MIN":0.6}


//////////////////
// WEBPACK FOOTER
// ./src/app/game/data/config.json
// module id = ncwc
// module chunks = 1